"use client";

import { trpc } from "@/util/trpc";
import { useState } from "react";
import { EditAddress } from "./common/address-edit";
import { EditBankDetails } from "./common/bank-details-edit";
import { EditVat } from "./common/edit-vat";
import { PaymentMethod } from "./common/payment-method";
import { Success } from "./common/success";
import { PayoutConfirm } from "./confirm";
import { Idle } from "./idle";

export function ClaimDialogContent({
    claims,
    onSuccess,
}: { claims: { type: "campaign" | "youtube"; id: string }[]; onSuccess: () => void }) {
    const [progress, setProgress] = useState<
        | { type: "idle" }
        | { type: "payment-method" }
        | { type: "confirm"; paymentMethod: "bank" | "crypto" }
        | { type: "edit-address"; paymentMethod: "bank" | "crypto" }
        | { type: "edit-bank-details"; paymentMethod: "bank" | "crypto" }
        | { type: "edit-vat"; paymentMethod: "bank" | "crypto" }
        | { type: "success"; paymentMethod: "bank" | "crypto" }
    >({
        type: "idle",
    });

    const { data: payoutsSummary } = trpc.edge.utils.getPayoutsSummary.useQuery({
        filter: claims,
    });

    return (
        <>
            {progress.type === "idle" && (
                <Idle
                    claims={claims}
                    onClick={() => {
                        setProgress({ type: "payment-method" });
                    }}
                />
            )}
            {progress.type === "payment-method" && (
                <PaymentMethod
                    onChoose={(method) => setProgress({ type: "confirm", paymentMethod: method })}
                    currency={payoutsSummary?.totalCurrency ?? "USD"}
                />
            )}
            {progress.type === "confirm" && (
                <PayoutConfirm
                    claims={claims}
                    method={progress.paymentMethod}
                    goBack={() => {
                        setProgress({ type: "payment-method" });
                    }}
                    onSuccess={() => {
                        setProgress({ type: "success", paymentMethod: progress.paymentMethod });
                        onSuccess();
                    }}
                    onAddressEdit={() => {
                        setProgress({ type: "edit-address", paymentMethod: progress.paymentMethod });
                    }}
                    onBankDetailsEdit={() => {
                        setProgress({ type: "edit-bank-details", paymentMethod: progress.paymentMethod });
                    }}
                    onVatEdit={() => {
                        setProgress({ type: "edit-vat", paymentMethod: progress.paymentMethod });
                    }}
                />
            )}
            {progress.type === "edit-address" && (
                <EditAddress
                    goBack={() => {
                        setProgress({ type: "confirm", paymentMethod: progress.paymentMethod });
                    }}
                />
            )}
            {progress.type === "edit-bank-details" && (
                <EditBankDetails
                    goBack={() => {
                        setProgress({ type: "confirm", paymentMethod: progress.paymentMethod });
                    }}
                />
            )}
            {progress.type === "edit-vat" && (
                <EditVat
                    goBack={() => {
                        setProgress({ type: "confirm", paymentMethod: progress.paymentMethod });
                    }}
                />
            )}
            {progress.type === "success" && <Success paymentMethod={progress.paymentMethod} />}
        </>
    );
}
